export default "__VITE_ASSET__C27R7JUO__"